import React, { useEffect, useReducer, useCallback } from 'react';
import { Grid } from '@mui/material';
import strings from "../Globalization/index";
import EndoSetupInterfaceConfigTable from '../AppGrid/EndoSetupInterfaceConfigTable';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';

const InterfaceConfig = () => {
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	useEffect(() => {
		setBreadcrumbs({
			docTitle: strings.InterfaceConfiguration,
			breadcrumbs: [{ text: strings.InterfaceConfiguration }]
		});
	}, []);

	return (
		<Grid container>
			<Grid size={12}>
				<EndoSetupInterfaceConfigTable />
			</Grid>
		</Grid>
	);
}

export default InterfaceConfig;